import React from 'react'
import PropTypes from 'prop-types'
import styles from 'layouts/WideLayout/WideLayout.module.scss'
import { Button, Icon } from 'gu-ui-kit'

export const CloseButton = ({ onClose = () => {} }) => (
  <Button
    noLabel
    variant={'ghost'}
    className={styles['layout__close-button']}
    onClick={onClose}
    size={'s'}
    color={'Interface-Eighth'}
    startIcon={<Icon name="undo" />}
  />
)

CloseButton.propTypes = {
  onClose: PropTypes.func,
}
